import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
// import { Paper } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import {
  setTicketNumber,
  setAddTicket,
} from '../HomePage/ContentTabs/ContentTabsSlice';
import {
  setEditedTicket,
  setValidationErrorsMultiLang,
} from '../EditTicket/EditTicketSlice';
import WagonNumberAutocomplete from '../WagonNumberAutocomplete/WagonNumberAutocomplete';
import AppBarWithTabs from '../AppBarWithTabs/AppBarWithTabs';
import Tab from '../AppBarWithTabs/Tab';
import {
  wagonNumberState,
  wagonDetailsState,
  ticketsHistoricState,
  // productHistoricState,
  selectedTabState,
  setWagonNumberResearched,
  setWagonDetails,
  setTicketsHistoric,
  setProductTypeHistory,
  setSelectedTab,
  setSortConfigForTicketHistoric,
  initializeRowsFiltersForTicketHistoric,
} from './WagonDetailsPageSlice';
import WagonDetailsTabContent from './WagonTechnicalDetailsTabContent/WagonDetailsTabContent';
import TicketsHistoricTabContent from './TicketsHistoricTabContent/TicketsHistoricTabContent';
// import ProductHistoryTabContent from './ProductHistoryTabContent/ProductHistoryTabContent';
import ApiService from '../../services/ApiService';
import EndAppBarWagonDetails from './EndAppBarWagonDetails';
import useStyles from './styles';
import i18n from '../../i18n';
import { userInfoState } from '../HomePage/HomeSlice';
import InvoicesListForWagon from './InvoicesListForWagon';
// import ActionsTable from '../ActionsTable/ActionsTable';

export default function WagonDetailsPage() {
  const classes = useStyles();
  const [errorPresent, setErrorPresent] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const wagonNumberResearched = useSelector(wagonNumberState);
  const selectedTab = useSelector(selectedTabState);
  const wagonDetails = useSelector(wagonDetailsState);
  const ticketsHistoric = useSelector(ticketsHistoricState);
  // const productTypeHistory = useSelector(productHistoricState);
  const isWagonDetailsPage = useLocation().pathname.includes('/wagon/details');
  const history = useHistory();
  const lang = i18n.language;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(userInfoState);

  const [errorMessageInSelectedLang, setErrorMessageInSelectedLang] =
    React.useState(null);

  const [expandedWagonGeneralDetails, setExpandedWagonDetails] =
    React.useState(true);
  const [
    expandedAdditionalActionForMaintenance,
    setExpandedAdditionalActionForMaintenance,
  ] = React.useState(true);
  const [expandedMaintenanceDetails, setExpandedMaintenanceDetails] =
    React.useState(true);
  const [expandedTechnicalDetails, setExpandedTechnicalDetails] =
    React.useState(true);
  const [expandedTankAndDischargement, setExpandedTankAndDischargement] =
    React.useState(true);
  const [expandedOtherWagonDetails, setExpandedOtherWagonDetails] =
    React.useState(false);

  useEffect(() => {
    if (errorMessage) {
      if (lang === 'en') {
        setErrorMessageInSelectedLang(errorMessage.messageEN);
      } else if (lang === 'fr') {
        setErrorMessageInSelectedLang(errorMessage.messageFR);
      } else if (lang === 'de') {
        setErrorMessageInSelectedLang(errorMessage.messageDE);
      } else {
        setErrorMessageInSelectedLang(errorMessage.messageEN);
      }
    }
  }, [lang, errorMessage]);
  function getWagonNumber(selectedWagonNumber) {
    dispatch(setWagonNumberResearched(selectedWagonNumber));
  }

  function getErrorPresent(newErrorPresent) {
    setErrorPresent(newErrorPresent);
  }

  function getErrorMessage(newErrorMessage) {
    setErrorMessage(newErrorMessage);
    if (newErrorMessage == null) {
      setErrorMessageInSelectedLang(null);
    }
  }

  function getSelectedTab(newTab) {
    dispatch(setSelectedTab(newTab));
  }

  function handleValidate() {
    ApiService.getWagonTechnicalDetailsWithHistoric(wagonNumberResearched)
      .then((response) => {
        dispatch(setTicketsHistoric(response.data.ticketsHistoric));
        dispatch(setProductTypeHistory(response.data.productTypeHistory));
        dispatch(setWagonDetails(response.data));
        dispatch(setSortConfigForTicketHistoric([]));
        dispatch(initializeRowsFiltersForTicketHistoric());
        history.push(`/wagon/details/${wagonNumberResearched}`);
      })
      .catch((error) => {
        if (error) {
          setErrorMessage(error);
        }
        setErrorPresent(true);
      });
  }
  function handleExpandAll() {
    setExpandedWagonDetails(true);
    setExpandedAdditionalActionForMaintenance(true);
    setExpandedMaintenanceDetails(true);
    setExpandedTechnicalDetails(true);
    setExpandedTankAndDischargement(true);
    setExpandedOtherWagonDetails(true);
  }
  function handleCollapseAll() {
    setExpandedWagonDetails(false);
    setExpandedAdditionalActionForMaintenance(false);
    setExpandedMaintenanceDetails(false);
    setExpandedTechnicalDetails(false);
    setExpandedTankAndDischargement(false);
    setExpandedOtherWagonDetails(false);
  }
  function handleExpandedChange(section, newExpanded) {
    switch (section) {
      case 'generalWagonDetails':
        setExpandedWagonDetails(newExpanded);
        break;
      case 'additionalActionForMaintenance':
        setExpandedAdditionalActionForMaintenance(newExpanded);
        break;
      case 'maintenanceDetails':
        setExpandedMaintenanceDetails(newExpanded);
        break;
      case 'technicalDetails':
        setExpandedTechnicalDetails(newExpanded);
        break;
      case 'tankAndDischargement':
        setExpandedTankAndDischargement(newExpanded);
        break;
      case 'otherWagonDetails':
        setExpandedOtherWagonDetails(newExpanded);
        break;
      default:
        break;
    }
  }
  const retrieveTicketInfos = (response) => {
    if (response.status) {
      dispatch(setTicketNumber(response.data.ticket.ticketNumber));
      dispatch(setEditedTicket(response.data.ticket));
      dispatch(setValidationErrorsMultiLang(response.data.validationErrors));
      history.push(`/ticket/details/${response.data.ticket.ticketNumber}`);
    } else {
      dispatch(setEditedTicket(response));
      dispatch(setValidationErrorsMultiLang({}));
      dispatch(setAddTicket(true));
      history.push(`/ticket/creation`);
    }
  };

  function addTicket() {
    ApiService.getTicketByWagonNumber(
      wagonDetails.wagonTechnicalDetails.wagonNumber,
    )
      .then((response) => {
        retrieveTicketInfos(response);
      })
      .catch((error) => {
        if (error) {
          setErrorMessage(error);
        }
        setErrorPresent(true);
      });
  }

  return (
    <div className={classes.root}>
      {isWagonDetailsPage && wagonDetails.wagonStatus !== 'deleted' && (
        <Tooltip TransitionComponent={Fade} title={t('add a new ticket')} arrow>
          <IconButton
            aria-label="add"
            data-testid="add-ticket"
            className={classes.addButton}
            onClick={addTicket}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}

      <Grid container spacing={0}>
        <Typography className={classes.title}>{t('Wagon Research')}</Typography>
        <TableContainer>
          <Table size="medium" aria-label="wagon-search-bar">
            <TableBody className={classes.tableBody}>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.autocomplete}
                >
                  <FormLabel className={classes.subtitle}>
                    {t('Wagon number')}
                  </FormLabel>
                  <WagonNumberAutocomplete
                    deletedIntegrated
                    selectedTab="wagonDetails"
                    wagonNumber={wagonNumberResearched}
                    errorPresent={errorPresent}
                    errorMessage={errorMessageInSelectedLang}
                    setErrorPresent={getErrorPresent}
                    setErrorMessage={getErrorMessage}
                    setWagonNumber={getWagonNumber}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  <Button
                    className={classes.validateButton}
                    variant="contained"
                    autoFocus
                    onClick={handleValidate}
                    color="secondary"
                    disabled={wagonNumberResearched === ''}
                  >
                    {t('Validate')}
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* {selectedTab === 'ticketsHistoric' && (
        <div>
          <Typography className={classes.title}>
            {t('additional_action_for_maintenance')}
          </Typography>
          <Paper className={classes.paper}>
            <ActionsTable />
          </Paper>
        </div>
      )} */}

      {isWagonDetailsPage && (
        <div>
          <Grid container spacing={0}>
            <Grid item xs={8}>
              {user.externalMax ? (
                <AppBarWithTabs
                  firstTabTitle={t('Wagon details')}
                  secondTabTitle={t('Tickets historic')}
                  firstTabName="wagonDetails"
                  secondTabName="ticketsHistoric"
                  selectedTab={selectedTab}
                  setSelectedTab={getSelectedTab}
                />
              ) : (
                <AppBarWithTabs
                  firstTabTitle={t('Wagon details')}
                  secondTabTitle={t('Tickets historic')}
                  thirdTabTitle={t('Invoices historic')}
                  fourthTabTitle={t('product_history')}
                  firstTabName="wagonDetails"
                  secondTabName="ticketsHistoric"
                  thirdTabName="invoicesHistoric"
                  fourthTabName="productTypeHistory"
                  selectedTab={selectedTab}
                  setSelectedTab={getSelectedTab}
                />
              )}
            </Grid>
            <Grid item xs={4} className={classes.endOfAppBarStyle}>
              <EndAppBarWagonDetails
                classes={classes}
                selectedTab={selectedTab}
                handleExpandAll={handleExpandAll}
                handleCollapseAll={handleCollapseAll}
                expandedAll={
                  expandedWagonGeneralDetails &&
                  expandedAdditionalActionForMaintenance &&
                  expandedMaintenanceDetails &&
                  expandedTechnicalDetails &&
                  expandedTankAndDischargement &&
                  expandedOtherWagonDetails
                }
                collapsedAll={
                  !(
                    expandedWagonGeneralDetails ||
                    expandedAdditionalActionForMaintenance ||
                    expandedMaintenanceDetails ||
                    expandedTechnicalDetails ||
                    expandedTankAndDischargement ||
                    expandedOtherWagonDetails
                  )
                }
              />
            </Grid>
          </Grid>
          <Tab selectedTab={selectedTab} index="wagonDetails">
            <WagonDetailsTabContent
              wagonDetails={wagonDetails}
              classes={classes}
              expandedWagonGeneralDetails={expandedWagonGeneralDetails}
              expandedAdditionalActionForMaintenance={
                expandedAdditionalActionForMaintenance
              }
              expandedMaintenanceDetails={expandedMaintenanceDetails}
              expandedTechnicalDetails={expandedTechnicalDetails}
              expandedTankAndDischargement={expandedTankAndDischargement}
              expandedOtherWagonDetails={expandedOtherWagonDetails}
              handleChange={handleExpandedChange}
            />
          </Tab>
          <Tab selectedTab={selectedTab} index="ticketsHistoric">
            <TicketsHistoricTabContent ticketsHistoric={ticketsHistoric} />
          </Tab>
          {user.hasAllRights && (
            <Tab selectedTab={selectedTab} index="invoicesHistoric">
              <div data-testid="invoices-list">
                <InvoicesListForWagon
                  wagonNumber={wagonDetails.wagonTechnicalDetails.wagonNumber}
                />
              </div>
            </Tab>
          )}
          {/* <Tab selectedTab={selectedTab} index="productTypeHistory">
            <ProductHistoryTabContent productTypeHistory={productTypeHistory} />
          </Tab> */}
        </div>
      )}
    </div>
  );
}
